<template>
    <div> 
        <div class="line__vertical-mains"></div>
        <!-- <promotion-alert>
        36
        </promotion-alert> -->
        <sub-header :micrositeUrl="micrositeUrl" />
        <div v-if="locations.length > 0" class="map_filter">
            <div class="maphighlight__box">
                <!-- <Promotion class="promotion_mobile">36</Promotion> -->
                  <h1 class="caption__select">
                  <span>Seleccione una manzana, clic para ver detalles</span>
                </h1>
                <map-highlight class="pradosur-indicators" :pradosur="true" v-for="(img, index) in imgSet" :key="img.width" :index="index" :img="img" :existFilter="existFilter" :desarrollo="desarrollo" :url="url" :nivel="nivel" :indicators="indicators" />
                <Button v-for="(img, index) in imgSet" :key="img.url" :index="index" :img="img" :id="id" :nivel="nivel" :desarrollo="desarrollo" :levelId="levelId" :url="url" />
                <div class="line_horizontal"></div>
                <Availables class="availables-mobile" :amountAvailables="amountAvailables" :nivel="nivel" />
            </div>
            <div class="select__box" :class="selectHide">
                <Select v-if="locations.length > 0 && rangeFilter.length > 0" :locations="locations" @change="changeRange" :rangeFilter="rangeFilter" />
                <Availables class="availables-desk" :amountAvailables="amountAvailables" :nivel="nivel" />
                <!-- <Promotion class="promotion_web">36</Promotion> -->
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import SubHeader from "../../core/SubHeader.vue";
import MapHighlight from "../../core/MapHighlight";
import Select from "../../core/Select.vue";
import Availables from "../../core/Availables.vue";
import Button from "../../core/Button.vue";
//import PromotionAlert from "../../core/PromotionAlert";
//import Promotion from "../../core/Promotion";
export default {
    name: "Main",
    components: {
        SubHeader,
        MapHighlight,
        //PromotionAlert,
        //Promotion,
        Select,
        Availables,
        Button,
    },
    data() {
        return {
            id: 86,
            nivel: "towerStageLevel",
            levelId: 0,
            desarrollo: "pradosur",
            arrFilteredLocations: [],
            url: "pradosur",
            micrositeUrl: "https://www.tresmarias.com.mx/",
            imgSet: [{
                name: 'pradosur',
                url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/pradosur/MainPradoSur.png',
                width: '5146',
                height: '6869',
                id: 86,
                levelId: 0,
                route: 'pradosur',
                nivel: 'towerStageLevel',
                transform: '',
                viewBox: '0 0 5146 6869'
            }],
           indicators: [
                { id: 238, text: 'MANZANA 1', transform: 'matrix(1 0 0 1 4419 4183)', cxB: 4330.52, cyB: 4090.33, rB: 81.58, cxW: 4330.52, cyW: 4090.33, rW: 46.29, x1: 3850.82, y1: 3434.5, x2: 4268.94, y2: 4045.63, status: true },
                { id: 239, text: 'MANZANA 2', transform: 'matrix(1 0 0 1 4489 3593)', cxB: 4506.31, cyB: 3434.5, rB: 81.58, cxW: 4506.31, cyW: 3434.5, rW: 46.29, x1: 4121.46, y1: 2875.25, x2: 4467, y2: 3380.3, status: true },
                { id: 240, text: 'MANZANA 3', transform: 'matrix(1 0 0 1 4620 2923)', cxB: 4827.25, cyB: 2752.4, rB: 81.58, cxW: 4827.25, cyW: 2752.4, rW: 46.29, x1: 4271.25, y1: 2169.5, x2: 4779.56, y2: 2690.82, status: true },
                { id: 245, text: 'MANZANA 8', transform: 'matrix(1 0 0 1 175 3253)', cxB: 796.14, cyB: 3147.02, rB: 81.58, cxW: 796.14, cyW: 3147, rW: 46.29, x1: 1530.18, y1: 2830.16, x2: 869.05, y2: 3108.04, status: true },
                { id: 246, text: 'MANZANA 9', transform: 'matrix(1 0 0 1 0 2783)', cxB: 596.14, cyB: 2697.02, rB: 81.58, cxW: 596.14, cyW: 2697, rW: 46.29, x1: 1330.18, y1: 2430.16, x2: 669.05, y2: 2658.04, status: true },
            ],
            // si no hay filtro volver rangeFilter a false
            rangeFilter: false
        };
    },

    computed: {
        ...mapGetters({
            locations: "getLocations",
        }),
        development() {
            return { id: this.id, level: 0 };
        },
        existFilter() {
            let arrExistFilter;
            if (this.rangeFilter) {
                arrExistFilter = this.arrFilteredLocations;
            } else if (this.rangeFilter === false) {
                arrExistFilter = this.locations;
            }
            return arrExistFilter;
        },
        returnAvailable() {
            const filteredAvailables = this.existFilter;
            const newArrfiltered = filteredAvailables.filter(
                (item) => item.available > 0
            );
            return newArrfiltered;
        },
      amountAvailables() {
            const filteredAvailables = this.existFilter;
            const newArrfiltered = filteredAvailables.filter(item =>
                this.indicators.some(ind => ind.id === item.id)
            );
            return newArrfiltered;
        },

        selectHide() {
            if (this.rangeFilter == false) {
                return 'u__dipslay--none'
            } else {
                return ''
            }
        }
    },
    methods: {
        ...mapActions(["getTowerStageLevels", "clearCoords"]),
        changeRange(arrFilter) {
            this.arrFilteredLocations = arrFilter;
        },
    },
    async created() {
        await this.clearCoords();
        await this.getTowerStageLevels(this.development);
    },
    async beforeDestroy() {
        await this.clearCoords()
    }
};
</script>
